
export default (number, prefix) => {
  if (number === null || number === undefined) return ''
  const str = String(number)
  const currency = str.split('.')

  return (prefix)
    ? prefix + currency[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    : currency[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}
